module.exports = __webpack_public_path__ + "img/hero.5c58d44e.png";